var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"driver-stats"},_vm._l((_vm.items),function(item){return _c('DriverSettlementStatCard',_vm._b({key:item.key},'DriverSettlementStatCard',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }